import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { isAuth } from './isAuth';

export function NotRequireAuth({ children }: { children: ReactNode }) {
    if (isAuth()) {
        return <Navigate to='/dashboard' replace />;
    }
    return <>{children}</>;
}
